if (
  process.env.NODE_ENV !== 'development' &&
  window.location.protocol !== 'https:' &&
  window.location.hostname !== 'localhost'
) {
  window.location.replace(`https:${window.location.href.substring(window.location.protocol.length)}`)
}
